var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveringOrderStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#E6F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12950_46150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8472 9.99989C31.9008 10.0075 34.2881 12.7552 33.9747 15.8673C33.7889 17.7154 33.0437 19.3252 32.0679 20.8447C31.2708 22.076 30.3438 23.2123 29.3037 24.233C28.9027 24.6318 28.7844 24.6353 28.3907 24.2413C26.782 22.6281 25.3993 20.844 24.4663 18.7224C23.9984 17.6644 23.705 16.5609 23.6843 15.3927C23.6288 12.4459 25.9794 9.993 28.8472 9.99989ZM28.8425 17.672C29.2985 17.6705 29.7438 17.5293 30.1219 17.2665C30.4999 17.0036 30.7936 16.6309 30.9658 16.1957C31.138 15.7605 31.1808 15.2824 31.0888 14.8221C30.9968 14.3617 30.7742 13.94 30.4492 13.6102C30.1243 13.2805 29.7116 13.0578 29.2635 12.9703C28.8155 12.8827 28.3523 12.9344 27.9328 13.1187C27.5133 13.3029 27.1564 13.6115 26.9074 14.0052C26.6583 14.3989 26.5284 14.86 26.5341 15.33C26.5422 15.9545 26.7888 16.5506 27.2204 16.989C27.652 17.4274 28.2339 17.6728 28.8399 17.672H28.8425Z",
    fill: "url(#paint0_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 15,
    r: 3,
    fill: "#E5F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6091 32.3558H10.8018C11.1153 30.2425 12.2681 28.9261 14.2478 28.3344C14.2036 28.1044 14.1595 27.8784 14.1141 27.6525C13.9985 27.0401 14.348 26.5965 14.9502 26.5903C15.134 26.5903 15.3178 26.5903 15.5016 26.5903C16.0529 26.6 16.3998 27.0208 16.3143 27.5788C16.2748 27.8309 16.2267 28.0816 16.1806 28.3482C17.2579 28.6237 18.1274 29.1955 18.7764 30.1019C19.2492 30.7604 19.5372 31.54 19.6091 32.3558Z",
    fill: "url(#paint1_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3975 34C10.1779 34 10 33.822 10 33.6025C10 33.383 10.1779 33.2051 10.3975 33.2051H19.9985C20.218 33.2051 20.396 33.383 20.396 33.6025C20.396 33.822 20.218 34 19.9985 34H10.3975Z",
    fill: "url(#paint2_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1397 22.4909C17.2195 22.2756 17.4602 22.1674 17.6742 22.2506L19.907 23.1185C20.1157 23.1997 20.2204 23.4345 20.1426 23.6445C20.0629 23.8597 19.823 23.9668 19.609 23.8838L17.3765 23.0173C17.167 22.936 17.0615 22.7016 17.1397 22.4909Z",
    fill: "url(#paint3_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7786 18.5335C12.5706 18.533 12.3941 18.3734 12.4031 18.1655C12.4471 17.1489 13.0399 16.2045 13.9057 15.7651C14.1112 15.6609 14.3456 15.7799 14.4165 15.9992C14.4832 16.2054 14.3818 16.4302 14.1968 16.5431C13.6094 16.9014 13.2835 17.4261 13.2083 18.121C13.184 18.3464 13.0053 18.5341 12.7786 18.5335Z",
    fill: "url(#paint4_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6248 25.4003C24.5459 25.6169 24.3034 25.7282 24.0885 25.6448L21.8573 24.7783C21.6497 24.6977 21.5443 24.4662 21.6199 24.2567C21.6982 24.0398 21.9396 23.93 22.1545 24.0136L24.3874 24.882C24.5946 24.9626 24.7009 25.1914 24.6248 25.4003Z",
    fill: "url(#paint5_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0362 32.3373C25.8169 32.3373 25.6391 32.1595 25.6391 31.9402C25.6391 31.7209 25.8169 31.5431 26.0362 31.5431H28.4329C28.6286 31.5431 28.7925 31.6682 28.8226 31.8616C28.8601 32.1024 28.6766 32.3373 28.4328 32.3373H26.0362Z",
    fill: "url(#paint6_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4088 16.258C16.1914 16.258 16.0151 16.0818 16.0151 15.8644C16.0151 15.647 16.1914 15.4707 16.4088 15.4707H18.8028C19.0202 15.4707 19.1964 15.647 19.1964 15.8644C19.1964 16.0818 19.0202 16.258 18.8028 16.258H16.4088Z",
    fill: "url(#paint7_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7664 31.1117C30.6387 31.2994 30.3763 31.3022 30.2108 31.1466C30.0544 30.9995 30.0379 30.7599 30.1451 30.5738C30.4963 29.9648 30.5394 29.3387 30.265 28.6832C30.1814 28.4836 30.2284 28.2463 30.4035 28.1193C30.582 27.9899 30.834 28.0183 30.9401 28.2115C31.4005 29.0504 31.326 30.2888 30.7664 31.1117Z",
    fill: "url(#paint8_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6173 31.5603C23.8366 31.5603 24.0144 31.7381 24.0144 31.9574C24.0144 32.1767 23.8366 32.3545 23.6173 32.3545H21.2349C21.0156 32.3545 20.8378 32.1767 20.8378 31.9574C20.8378 31.7381 21.0156 31.5603 21.2349 31.5603H23.6173Z",
    fill: "url(#paint9_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1209 26.0068C26.2002 25.7908 26.4413 25.682 26.6557 25.7653L28.887 26.6328C29.0949 26.7136 29.1997 26.9465 29.1231 27.156C29.0444 27.3714 28.8045 27.4797 28.5907 27.3969L26.3582 26.5316C26.1493 26.4506 26.0437 26.2171 26.1209 26.0068Z",
    fill: "url(#paint10_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3965 21.3692C15.6014 21.4464 15.697 21.6726 15.6212 21.878C15.5387 22.1016 15.2857 22.2155 15.0642 22.1275C14.6564 21.9657 14.2582 21.8109 13.8743 21.6252C13.441 21.4177 13.0995 21.0987 12.8468 20.6758C12.7379 20.4935 12.824 20.2642 13.0148 20.171C13.2186 20.0715 13.4604 20.1676 13.5932 20.3514C14.0267 20.9517 14.7316 21.1186 15.3965 21.3692Z",
    fill: "url(#paint11_linear_12950_46150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8051 15.8661C22.8051 16.0852 22.6275 16.2629 22.4084 16.2629H21.2296C21.0105 16.2629 20.8329 16.0852 20.8329 15.8661C20.8329 15.647 21.0105 15.4694 21.2296 15.4694H22.4084C22.6275 15.4694 22.8051 15.647 22.8051 15.8661Z",
    fill: "url(#paint12_linear_12950_46150)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12950_46150",
    x: 6,
    y: 6.99988,
    width: 32.0024,
    height: 32.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.239216 0 0 0 0 0.682353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12950_46150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12950_46150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12950_46150",
    x1: 25.4284,
    y1: 10.8572,
    x2: 31.857,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12950_46150",
    x1: 12.9997,
    y1: 27.5714,
    x2: 18.9997,
    y2: 32.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12950_46150",
    x1: 15.198,
    y1: 33.2051,
    x2: 15.198,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12950_46150",
    x1: 18.6409,
    y1: 22.0992,
    x2: 18.6409,
    y2: 24.0348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12950_46150",
    x1: 13.4679,
    y1: 15.6099,
    x2: 13.4679,
    y2: 18.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12950_46150",
    x1: 23.1217,
    y1: 23.8612,
    x2: 23.1217,
    y2: 25.7968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12950_46150",
    x1: 27.2678,
    y1: 31.5431,
    x2: 27.2678,
    y2: 32.3373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12950_46150",
    x1: 17.6058,
    y1: 15.4707,
    x2: 17.6058,
    y2: 16.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12950_46150",
    x1: 30.5885,
    y1: 27.8901,
    x2: 30.5885,
    y2: 31.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12950_46150",
    x1: 22.4261,
    y1: 31.5603,
    x2: 22.4261,
    y2: 32.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12950_46150",
    x1: 27.6216,
    y1: 25.6135,
    x2: 27.6216,
    y2: 27.5477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12950_46150",
    x1: 14.2138,
    y1: 19.9879,
    x2: 14.2138,
    y2: 22.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12950_46150",
    x1: 21.819,
    y1: 15.4694,
    x2: 21.819,
    y2: 16.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveringOrderStatus);
export default __webpack_public_path__ + "static/media/delivering-order-status.2ebae6fcd9e85f303c77bf6df287486d.svg";
export { ForwardRef as ReactComponent };